import React from 'react';
import Lottie from 'react-lottie';
import description from '@graphic/description.json';
import icon_diversity from '@graphic/icon_diversity.json';
import invitation from '@graphic/invitation.json';
import classnames from 'classnames/bind';
import styles from './rollingText.module.scss';
const cx = classnames.bind(styles);

const visual1Options = {
  loop: true,
  autoplay: false,
  animationData: description,
};

const visual2Options = {
  loop: true,
  autoplay: false,
  animationData: invitation,
};

const visual3Options = {
  loop: true,
  autoplay: false,
  animationData: icon_diversity,
};

interface rollingProps {
  rolling: boolean;
}

const RollingText = ({ rolling }: rollingProps) => {
  return (
    <div className={cx('rollingIntro')}>
      <span className={cx('mainText')}>더 이상</span>
      <div className={cx('rollingArea')}>
        <div className={cx('change-word')}>
          <div className={cx(rolling ? 'change-inner' : null)}>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual1Options} />
              </div>
              자기소개서
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual2Options} />
              </div>
              입사지원서
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual3Options} />
              </div>
              스펙<span className={cx('spec')}>SPEC</span>
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual1Options} />
              </div>
              자기소개서
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual2Options} />
              </div>
              입사지원서
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual3Options} />
              </div>
              스펙<span className={cx('spec')}>SPEC</span>
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual1Options} />
              </div>
              자기소개서
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual2Options} />
              </div>
              입사지원서
            </p>
            <p className={cx('rollingText')}>
              <div className={cx('visualWrap')}>
                <Lottie options={visual3Options} />
              </div>
              스펙<span className={cx('spec')}>SPEC</span>
            </p>
          </div>
        </div>
      </div>
      <span className={cx('mainText')}>신경 쓰지 마세요.</span>
    </div>
  );
};

export default RollingText;
